// CORE
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

// INTERFACE
import { IMenuData } from "../../../interfaces/shared/menu-home.interface";
import { Ipermission } from './../../../interfaces/shared/permission.interface';

// SERVICES
import { LocalStorageService } from "./../../../services/shared/local-storage/local-storage.service";
import { MenuService } from "./../../../services/shared/menu/menu.service";
import { AbmService } from "./../../../services/shared/abm/abm.service";
import { SharedService } from "./../../../services/shared/shared.service";

// ENTITIE
import { MenuAbmModel, MenuAppsModel } from "./../../../entities/shared/MenuApps";
import { OptionMenuApps } from "src/app/enums/shared";

import { environment } from "src/environments/environment";

@Component({
  selector: "app-menu-home",
  templateUrl: "./menu-home.component.html",
  styleUrls: ["./menu-home.component.scss"],
  standalone: false
})
export class MenuHomeComponent implements OnInit {

  menuData: IMenuData[];
  subTituloHtml: string;
  isVip: boolean;
  isRds = false;

  get userName(): string {
    return this.localStorageService.dataLogin.getName();
  }

  get permissions() {
    //return environment.DATA_PERMISSION_PRIVATE.menuApp;

    return {
      dm: this.localStorageService.configInit["F_DM_A"],
      pp: this.localStorageService.configInit["F_PP_A"] || this.localStorageService.configInit["F_DM_A"],
      abm: this.localStorageService.configInit["F_ABM_A"],
      seguimientoReqid: this.localStorageService.configInit["F_ABM_A"],
      merge: this.localStorageService.configInit["F_MERGE_A"],
      bulk: this.localStorageService.configInit["F_BULK_A"],
      logs: this.localStorageService.configInit["F_LOG_A"],
      rds: this.localStorageService.configInit["F_RDS_A"],
      dissociate: this.localStorageService.configInit["F_DISSOCIATE_A"],
      contribution: this.localStorageService.configInit["F_CONTRIBUTION_A"]
    }
  }

  get permissionCountry(): Ipermission {
    return this.localStorageService.getPermissionCountry;
  }

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private menuService: MenuService,
    private abmService: AbmService,
    private sharedService: SharedService
  ) {
  }

  ngOnInit(): void {
    this.isVip = this.localStorageService.getIsVip;
    this.isRds = this.localStorageService.getIsExternoRDS;
    this.initMenuApp();
    this.voidModuleScreenForVipRds();
    this.suscribreRegionSelect();
    this.suscribeChangeMenuItem();
    this.suscribeMenuApp();
    this.suscribeAbmMenuSelect();
  }

  initMenuApp() {
    this.menuData = MenuAppsModel;
    this.subTituloHtml = '¿Qué quieres hacer?';
  }

  voidModuleScreenForVipRds() {
    if (this.localStorageService.getIsVip) {
      this.setMenuLocalService(MenuAppsModel.find(dataApp => dataApp.title === OptionMenuApps.DM));
    }
    if (this.localStorageService.getIsExternoRDS) {
      let MenuAppsModelRdsSelected = MenuAppsModel.find(dataApp => dataApp.title === OptionMenuApps.MENU_RDS);
      this.setMenuLocalService(MenuAppsModelRdsSelected);
      // this.selectMenuButton(MenuAppsModelRdsSelected);
    }
  }

  suscribeChangeMenuItem() {
    this.menuService.getMenu().subscribe({
      next: (response) => {
        console.log("Menu desde API: ", response);
        if (response?.items && Array.isArray(response.items)) {
          // Procesar los items del menú recibidos desde la API
          this.processMenuItems(response.items);
        }
      },
      error: (error) => {
        console.error("Error al obtener el menú:", error);
      }
    });
  }

  suscribeMenuApp() {
    this.localStorageService.getMenuAppObs.subscribe((menuApp) => {
      if (menuApp?.title === OptionMenuApps.MANTENEDOR) {
        // Cuando se selecciona Mantenedor desde el navbar, mostrar el sub-menú
        this.setABMsubMenu();
        const country = this.localStorageService.getRegionSeleccionada;
        if (country) {
          this.menuData.forEach((menu) => {
            if (menu.countryView && !menu.countryView.includes(country.getCode())) {
              menu.disabled = true;
            }
            menu.hover = false;
          });
        }
        this.applyServiceViewFilter(this.abmService.menuSelectedData?.service || country?.getService());
      }
    });
  }

  private processMenuItems(items: any[]) {
    // Aquí puedes procesar los items del menú según la lógica de negocio
    // Por ejemplo, actualizar menuData con los items recibidos
    console.log("Procesando items del menú:", items);
    // TODO: Implementar la lógica de procesamiento según los requisitos
  }

  suscribreRegionSelect() {
    this.localStorageService.regionSeleccionada.subscribe((country) => {
      // console.log("PAIS SELECCIONADO: " + country.getName());
      // console.log('Role pais', this.permissionCountry);
      this.initMenuApp();
      this.menuData.forEach((menu) => {
        // console.log("menu ----->", menu);
        menu.disabled = this.permissionCountry?.roles
          ? !this.sharedService.parseRolesArray(this.permissions[menu.permissionName]).includes(this.permissionCountry.roles)
          : true;
        if (menu.hasOwnProperty("countryView") && !menu.countryView?.includes(country.getCode())) {
          // console.log("esta disponible", country.getCode());
          menu.disabled = true;
        }
        if (menu.serviceView && !menu.serviceView.includes(country.getService()?.toLowerCase())) {
          menu.disabled = true;
        }
        if (menu.subItems?.length) {
          menu.subItems.forEach((sub) => {
            if (sub.serviceView && !sub.serviceView.includes(country.getService()?.toLowerCase())) {
              sub.disabled = true;
            }
          });
        }
        menu.hover = false;
      });
      this.localStorageService.setMenuConfig = this.menuData;
    });
  }

  setABMsubMenu() {
    this.menuData = MenuAbmModel.map(item => ({ ...item }));
    this.subTituloHtml = 'Seleccione Mantenedor';
  }

  suscribeAbmMenuSelect() {
    this.abmService.menuSelected$.subscribe((menuSelected) => {
      if (this.subTituloHtml === 'Seleccione Mantenedor') {
        this.applyServiceViewFilter(menuSelected?.service || this.localStorageService.getRegionSeleccionada?.getService());
      }
    });
  }

  private applyServiceViewFilter(service?: string): void {
    const normalizedService = service?.toLowerCase();
    this.menuData?.forEach((menu) => {
      if (menu.serviceView) {
        menu.disabled = !normalizedService || !menu.serviceView.includes(normalizedService);
      }
    });
  }

  selectMenuButton(menuSelected: IMenuData) {
    this.setMenuLocalService(menuSelected);
    this.routeMenuSelected(menuSelected);

    if (menuSelected?.title === OptionMenuApps.MANTENEDOR) {
      this.localStorageService.regionSeleccionada.subscribe((country) => {
        // console.log("PAIS SELECCIONADO: " + country.getName());
        // console.log('Role pais', this.permissionCountry);
        this.setABMsubMenu();
        this.menuData.forEach((menu) => {
          // menu.disabled = this.permissionCountry?.roles
          //   ? !this.permissions[menu.permissionName]?.includes(this.permissionCountry.roles)
          //   : true;
          if (menu.hasOwnProperty("countryView") && !menu.countryView?.includes(country.getCode())) {
            // console.log("esta disponible", country.getCode());
            menu.disabled = true;
          }
          menu.hover = false;
        });
        this.applyServiceViewFilter(this.abmService.menuSelectedData?.service || country?.getService());
        // this.localStorageService.setMenuConfig = this.menuData;
      });
    }
  }

  setMenuLocalService(menuSelected: IMenuData) {
    // console.log('menuSelected', menuSelected);
    // console.log('this.localStorageService.getMenuApp', this.localStorageService.getMenuApp);
    if (menuSelected !== this.localStorageService.getMenuApp) {
      this.localStorageService.setMenuApp = menuSelected;
    }
  }

  routeMenuSelected(menuSelect: IMenuData) {
    console.log('menuSelect', menuSelect);
    let rutaIntExt = this.isVip
      ? 'routeVip'
      : this.isRds
        ? 'routeRds'
        : 'route';
    if (menuSelect?.[rutaIntExt]) {
      this.router.navigate([menuSelect[rutaIntExt], this.localStorageService.getRegionSeleccionada.getCode().toLowerCase()]);
    } else {
      this.router.navigateByUrl(
        this.localStorageService.getIsVip
          ? environment.URL_RETURN_APP_VIP
          : this.localStorageService.getIsExternoRDS
            ? environment.URL_RETURN_APP_RDS
            : environment.URL_RETURN_APP
      );
    }
  }

  mouseEnter(index: number) {
    this.menuData[index].hover = this.menuData[index].disabled ? false : true;
  }

  mouseLeave(index: number) {
    this.menuData[index].hover = false;
  }

  disabledVista(menu) {
    let letDisabledVista = !(
      this.isVip
        ? menu.disabledVip
        : this.isRds
          ? menu.disabledRds
          : menu.disabled
    );
    return letDisabledVista;
  }

}
